export const getMeasurementSystemFromLocale = (language = 'en') => {
  language = language.toLowerCase()

  return language.split('-')[0] === 'en' ? 'imperial' : 'metric'
}
